/* eslint-disable require-jsdoc */

export function selectFilteredNews(state) {
    return state.filteredNews.items;
}

export function selectFilteredNewsCategory(state) {
    return state.filteredNews.category;
}

export function selectFilteredNewsExcludeFeatured(state) {
    return state.filteredNews.excludeFeatured;
}

export function selectFilteredNewsIsBusy(state) {
    return state.filteredNews.isBusy;
}

export function selectFilteredNewsIsStale(state) {
    return state.filteredNews.isStale;
}

export function selectFilteredNewsFirstPage(state) {
    return state.filteredNews.firstPage;
}

export function selectFilteredNewsLastPage(state) {
    return state.filteredNews.lastPage;
}

export function selectFilteredNewsResultCount(state) {
    return state.filteredNews.resultCount;
}
